import { VoucherTypes } from './VoucherTypes';

export const columns = [
    {
      field: 'type',
      header: 'Comprobante',
      translate: (type) => VoucherTypes.labels[type] || type
    },
    {
      field: 'totalAmount',
      header: 'Importe',
      type: 'money'
    },
    {
      field: 'quantity',
      header: 'Tickets',
    },
];